<template>
	<div class="pa-4">
		<!--Header-->
		<page-title
			:divider="true"
			icon="document"
			title="Terms and Conditions"
		/>

		<!--Intro Notice-->
		<div class="appWhite rounded-lg pa-4 mt-4" style="border-left: 4px solid #d8252e">
			<app-text size="normal-bold" class="mb-2">WRU Accreditation Portal Media and Photographer T&Cs</app-text>
			<app-text color="grey9">PLEASE NOTE THERE ARE TWO DOCUMENTS: 1. GENERAL MEDIA 2. PHOTOGRAPHERS</app-text>
		</div>

		<!--Tabs-->
		<v-tabs v-model="activeTab" class="mt-4">
			<v-tab href="#general-media">
				<app-text size="small">General Media</app-text>
			</v-tab>
			<v-tab href="#photographers">
				<app-text size="small">Photographers</app-text>
			</v-tab>
		</v-tabs>

		<!--Tab Content-->
		<v-tabs-items v-model="activeTab">
			<!--General Media Tab-->
			<v-tab-item value="general-media">
				<div class="appWhite rounded-lg pa-6 mt-4">
					<div class="terms-content" v-html="generalMediaContent"></div>
				</div>
			</v-tab-item>

			<!--Photographers Tab-->
			<v-tab-item value="photographers">
				<div class="appWhite rounded-lg pa-6 mt-4">
					<div class="terms-content" v-html="photographersContent"></div>
				</div>
			</v-tab-item>
		</v-tabs-items>

		<!--Back Button-->
		<div class="d-flex justify-start mt-4">
			<app-btn
				@click.native="MIX_go('/')"
				icon="arrowBack"
				label="Back to Home"
			/>
		</div>
	</div>
</template>

<script>
import { generalMediaContent, photographersContent } from '@/views/termsAndConditions/termsAndConditionsContent'

export default {
	name: 'TermsAndConditions',

	data: () => ({
		activeTab: 'general-media',
		generalMediaContent,
		photographersContent,
	}),

	methods: {},
}
</script>

<style scoped>
.terms-content {
	max-width: 900px;
	margin: 0 auto;
	line-height: 1.6;
}

.terms-content >>> p {
	color: inherit;
}
</style>
